module.exports = __webpack_public_path__ + "static/media/ponzusauce.1b1e3a9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/flavor/ponzusauce.jpg
// module id = 148
// module chunks = 0